import { serialize } from './utils';
import browser from './device';

export default function (option) {
    console.log('option: ', option);
    let kiwi = browser.isIos && browser.isIpad ? 'yykiwihd:' : 'yykiwi:';
    let baseLink = 'https://secstatic.huya.com/huya?';
    let kiwiLink = `${kiwi}//homepage/index.html?banneraction=`;

    let updateLink = 'https://diy-front.cdn.huya.com/zt/frontpage/cc/update.html?';
    let { appAction, id, sid, eid, uid, gid, vid, momentid, momenttype, url, screenType, liveSourceType, source, decorateId, shareid, master_uid, skill_id } = option;
    let extra = {
        fromapp: source ? encodeURIComponent(source) : '',
        decorateid: decorateId || '',
        shareid: shareid || '',
    };
    let queryParams = option.queryParams ? ('&' + serialize(option.queryParams)) : '';
    let hyactionExtraParams = option.hyactionExtraParams ? ('&' + serialize(option.hyactionExtraParams)) : '';
    let hackIosFromAppBugParams = source ? ('&fromapp=' + source) : '';
    let retUrl;

    if (url) {
        return {
            universalLink: baseLink + 'kw_dispatch_url=' + url,
            schemaLink: kiwiLink + url + queryParams,
            appLink: decodeURIComponent(url),
        }
    } else {
        if (appAction) {
            retUrl = appAction;
        } else if (id && sid) {
            retUrl = 'hyaction=live&channelid=' + id + '&subid=' + sid + '&liveuid=' + uid + '&screentype=' + screenType + '&sourcetype=' + liveSourceType;
        } else if (uid) {
            retUrl = 'hyaction=live&uid=' + uid;
        } else if (eid) {
            retUrl = 'hyaction=forenotice&eventid=' + eid;
        } else if (vid) {
            retUrl = 'hyaction=recordedvideo&vid=' + vid;
        } else if (gid) {
            retUrl = 'hyaction=livelist&section_id=' + gid;
        } else if (master_uid && skill_id) {
            retUrl = 'hyaction=accompanymasterpage&src_type=5&reportrtserver=1&master_uid=' + master_uid + '&skill_id=' + skill_id;
        } else if (momentid && momenttype)
            retUrl = 'hyaction=realmoment&momentid=' + momentid + '&momenttype=' + momenttype;
        else {
            retUrl = 'hyaction=livelist';
        }

        retUrl += '&' + serialize(extra);

        return {
            universalLink: baseLink + retUrl + queryParams,
            schemaLink: kiwiLink + encodeURIComponent(updateLink + retUrl + hyactionExtraParams) + queryParams + hackIosFromAppBugParams,
            appLink: updateLink + retUrl + hyactionExtraParams + queryParams
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/getAppUrl.js